import {
  tableKeys,
  transportKeys,
  bucketKeys,
} from "@smart/bridge-resources-basic";
import { buildPermissionsDef } from "@smart/itops-constructs-basic";

import { apiGateway } from "./api-gateway";
import { webSocketGateway } from "./websocket-gateway";

const lambdaKeys = [...apiGateway.lambdaKeys, ...webSocketGateway.lambdaKeys];

export const permissions = buildPermissionsDef(
  lambdaKeys,
  tableKeys,
  transportKeys,
  bucketKeys,
  ["Bedrock", "Polly"],
  {
    createSubmission: {
      dynamo: { default: "READ" },
      sns: { default: null, Plan: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    load: {
      dynamo: { default: "READ" },
      sns: { default: null, Plan: "PUBLISH" },
      s3: { default: null, IntakeFormSnapshots: "READ" },
      additionalResources: { default: null },
    },
    submit: {
      dynamo: { default: "READ" },
      sns: { default: null, Plan: "PUBLISH", QuestionGeneration: "PUBLISH" },
      s3: { default: null, IntakeFormSnapshots: "READ" },
      additionalResources: { default: null },
    },
    searchAddress: {
      dynamo: { default: null },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    getAddress: {
      dynamo: { default: null },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    uploadFile: {
      dynamo: { default: "READ" },
      sns: { default: null },
      s3: { default: null, IntakeUploadedFiles: "WRITE" },
      additionalResources: { default: null },
    },
    captcha: {
      dynamo: { default: null },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    signNotify: {
      dynamo: { default: "READ" },
      sns: { default: null, SmokeballIntegration: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    voiceConversationWebSocket: {
      dynamo: { default: "READ" },
      sns: { default: null },
      s3: { default: null, IntakeFormSnapshots: "READ" },
      additionalResources: {
        default: null,
        Bedrock: "ACCESS",
        Polly: "ACCESS",
      },
    },
    analyticsEvent: {
      dynamo: { default: "READ" },
      sns: { default: null, EventAnalytics: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
  },
);

export const specialPermissions = buildPermissionsDef(
  ["load", "submit"],
  ["Operation", "SmokeballCommandResponse"],
  [],
  [],
  ["SmokeballCommands"],
  {
    load: {
      dynamo: {
        default: null,
        Operation: "WRITE",
        SmokeballCommandResponse: "READ",
      },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null, SmokeballCommands: "ACCESS" },
    },
    submit: {
      dynamo: {
        default: null,
        Operation: "WRITE",
        SmokeballCommandResponse: "READ",
      },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null, SmokeballCommands: "ACCESS" },
    },
  },
);
